<template>
    <el-dialog
        class="pay-confirm"
        :visible.sync="paymentVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="400px"
        title="Payment"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="pay-confirm_tip">
            After the payment is completed,click the button below according to
            the actual situation.
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="success"
                >Success</el-button
            >
            <el-button size="small" @click="paymentVisible = false"
                >Fail</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {};
    },
    methods: {
        closeDialog() {
            this.orderId ? this.getOrderDetail() : this.$emit("onClosed");
            this.$emit("update:paymentVisible", false);
        },
        success() {
            this.closeDialog();
        },
        getOrderDetail() {
            cmofferApi.orders({}, "get", this.orderId instanceof Array ? this.orderId.toString() : this.orderId).then((res) => {
                if (res) {
                    this.$emit("onClosed", res.data.status);
                    if (res.data.status == 1) {
                        this.$message.error(
                            `Order payment failed. Please click Pay Now to try again`
                        );
                    }
                }
            });
        },
    },
    props: {
        paymentVisible: Boolean,
        orderId: String | Number | Array
    },
    watch: {
        paymentVisible(val) {},
    },
};
</script>
<style lang="scss" scoped>
.pay-confirm {
    .pay-confirm_tip {
        line-height: 28px;
        padding: 10px 20px;
        font-size: 14px;
    }
}
</style>
